<template>
    <div class="min-h-screen flex items-center justify-center bg-gray-100">
        <div class="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
            <div class="flex">
                <img src="@/assets/logo.png" alt="Logo" class="h-8 mr-2" />
                <h1 class="text-2xl font-bold text-center text-gray-800">用户登录</h1>
            </div>
            <form @submit.prevent="handleLogin" class="space-y-6">
                <div>
                    <label for="username" class="block text-sm font-medium text-gray-700">账号</label>
                    <input type="text"
                           id="username"
                           v-model="username"
                           @blur="validateUsername"
                           placeholder="请输入账号"
                           class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" />
                    <span class="text-red-500 text-xs" v-if="usernameError">{{ usernameError }}</span>
                </div>

                <div>
                    <label for="password" class="block text-sm font-medium text-gray-700">密码</label>
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <input :type="showPassword ? 'text' : 'password'"
                               id="password"
                               v-model="password"
                               @blur="validatePassword"
                               placeholder="请输入密码"
                               class="block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" />
                        <button type="button"
                                @click="togglePasswordVisibility"
                                class="absolute inset-y-0 right-0 px-3 flex items-center text-gray-500 hover:text-gray-700">
                        </button>
                    </div>
                    <span class="text-red-500 text-xs" v-if="passwordError">{{ passwordError }}</span>
                </div>

                <div>
                    <button type="submit"
                            class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        登录
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'LoginPage',
        data() {
            return {
                username: '',
                password: '',
                usernameError: '',
                passwordError: '',
                showPassword: false,
            }
        },
        methods: {
            validateUsername() {
                if (!this.username.trim()) {
                    this.usernameError = '请输入账号'
                    return false
                }
                this.usernameError = ''
                return true
            },
            validatePassword() {
                if (!this.password) {
                    this.passwordError = '请输入密码'
                    return false
                }
                this.passwordError = ''
                return true
            },
            togglePasswordVisibility() {
                this.showPassword = !this.showPassword
            },
            async handleLogin() {
                const isUsernameValid = this.validateUsername()
                const isPasswordValid = this.validatePassword()

                if (!isUsernameValid || !isPasswordValid) return
                await this.loginManagerNews();
            },
            async loginManagerNews() {
                try {
                    console.log(this.username);
                    console.log(this.password);
                    const obj = { "username": this.username, "password": this.password };
                    const response = await axios({
                        method: 'post',
                        url: '/api/news/manager',
                        headers: {
                            'accept': 'application/json',
                            'Content-Type': 'application/json',
                        },
                        data: {
                            "sub": btoa(JSON.stringify(obj))
                        }
                    });
                    if (response.status !== 200) {
                        console.error('Failed to update no 200:');
                        console.error(response.data);
                        this.$message.error({ message: '网络状态异常！请稍后重试', duration: 3000 });
                    } else if (response.data.code == "00") {
                        this.$message.success({ message: '登录成功', duration: 3000 });
                        const redirect = this.$route.query.redirect
                        localStorage.setItem('isAuthenticated', 'true')
                        if (redirect) {
                            this.$router.push(redirect)
                        } else {
                            this.$router.push({ name: 'EditNews' })
                        }
                    } else {
                        this.$message({ message: response.data.message, type: 'error' });
                    }
                } catch (error) {
                    console.error('Failed to update:', error);
                    this.$message({
                        message: '网络异常，请稍后重试',
                        type: 'error'
                    });
                }
            },
        },
    }
</script>